import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import SectionTitle from '../components/SectionTitle';
import FeatureCard from '../components/FeatureCard';
import { BrainCircuitIcon, ServerIcon, CodeIcon } from 'lucide-react';
const ProductsPage = () => {
  const products = [{
    id: 'ph8',
    title: 'PH8 大模型MaaS平台',
    shortDescription: '企业级大模型即服务平台，赋能各行业AI应用',
    fullDescription: `PH8是我们自主研发的大模型即服务(MaaS)平台，为企业和开发者提供强大的AI能力。平台集成了多种先进的大语言模型，支持自然语言处理、内容生成、知识问答等多种场景。
通过PH8平台，企业可以轻松接入大模型能力，无需复杂的技术部署，即可快速构建智能应用。平台提供简洁的API接口和丰富的SDK工具，支持多种编程语言和开发环境。
核心优势：
- 多模型支持：集成国内外领先的开源和闭源大模型
- 高性能推理：优化的推理引擎，提供低延迟、高并发的服务能力
- 企业级安全：严格的数据隔离和安全保障机制
- 灵活部署：支持公有云、私有云和混合云多种部署方式
- 定制化服务：提供模型微调和定制化训练服务`,
    features: ['多模型集成与管理', '企业级安全与隐私保护', '高性能推理引擎', '丰富的API和SDK支持', '定制化模型训练与微调', '细粒度的成本控制'],
    image: 'https://images.unsplash.com/photo-1677442135968-6d89469c177e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    icon: <BrainCircuitIcon className="h-12 w-12" data-id="element-550" />
  }, {
    id: 'cloud',
    title: '普华云 异构算力服务平台',
    shortDescription: '高性能异构算力平台，满足AI训练与推理需求',
    fullDescription: `普华云是我们打造的异构算力服务平台，整合了GPU、NPU、TPU等多种异构计算资源，为AI训练和推理提供高性能、低延迟的计算服务。
平台采用先进的资源调度和负载均衡技术，实现计算资源的高效利用和动态扩展。用户可以根据实际需求灵活选择不同类型和规格的算力资源，按需付费，大幅降低AI应用的开发和运营成本。
核心优势：
- 丰富的算力资源：支持NVIDIA A100/H100、国产GPU和NPU等多种算力设备
- 智能调度系统：基于任务特性自动选择最优算力资源
- 弹性扩展：支持资源的自动扩缩容，满足峰值需求
- 完善的监控和运维工具：提供实时监控和故障自动处理能力
- 优化的网络架构：高带宽、低延迟的网络连接，提升数据传输效率`,
    features: ['多种异构算力资源', '智能资源调度系统', '弹性扩缩容能力', '完善的监控和运维工具', '高性能网络架构', '按需付费的灵活计费模式'],
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2034&q=80',
    icon: <ServerIcon className="h-12 w-12" data-id="element-551" />
  }, {
    id: 'wanli',
    title: '万里 大模型开发平台',
    shortDescription: '一站式大模型开发环境，加速AI应用落地',
    fullDescription: `万里大模型开发平台是一个一站式的大模型开发环境，涵盖了数据处理、模型训练、评估、部署的全流程工具链，大幅简化大模型开发流程，加速企业AI应用落地。
平台提供直观的可视化界面和完善的开发工具，支持开发者快速构建和优化大模型应用。同时，平台内置丰富的预训练模型和数据集，帮助开发者快速启动项目，避免从零开始的高成本研发。
核心优势：
- 全流程工具链：从数据处理到模型部署的完整工具支持
- 低代码开发：可视化界面和组件化设计，降低开发门槛
- 预训练资源：丰富的预训练模型和数据集
- 分布式训练：支持多机多卡的高效分布式训练
- 模型评估与优化：全面的评估指标和优化工具
- 一键部署：简化模型部署流程，支持多种部署环境`,
    features: ['全流程AI开发工具链', '低代码可视化开发环境', '丰富的预训练模型库', '高效分布式训练框架', '全面的模型评估与优化工具', '一键部署到多种环境'],
    image: 'https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    icon: <CodeIcon className="h-12 w-12" data-id="element-552" />
  }];
  return <div className="bg-white" data-id="element-553">
      <HeroSection title="产品与服务" subtitle="我们提供全面的AI技术产品和服务，满足企业在数字化转型中的各种需求" backgroundImage="https://images.unsplash.com/photo-1531297484001-80022131f5a1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" size="medium" data-id="element-554" />
      <section className="py-16 md:py-24" data-id="element-555">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-556">
          <SectionTitle title="我们的产品" subtitle="为企业数字化转型提供全方位的技术支持和解决方案" data-id="element-557" />
          <div className="space-y-16" data-id="element-558">
            {products.map((product, index) => <div key={product.id} className={`flex flex-col ${index % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-8 items-center`} data-id="element-559">
                <div className="w-full md:w-1/2" data-id="element-560">
                  <img src={product.image} alt={product.title} className="w-full h-auto rounded-lg shadow-lg" data-id="element-561" />
                </div>
                <div className="w-full md:w-1/2" data-id="element-562">
                  <div className="text-primary-500 mb-4" data-id="element-563">{product.icon}</div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-564">
                    {product.title}
                  </h3>
                  <p className="text-lg text-gray-600 mb-6" data-id="element-565">
                    {product.shortDescription}
                  </p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6" data-id="element-566">
                    {product.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-567">
                        <svg className="h-5 w-5 text-primary-500 mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-568">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-569" />
                        </svg>
                        <span className="text-gray-700" data-id="element-570">{feature}</span>
                      </li>)}
                  </ul>
                  <Link to={`/products/${product.id}`} className="inline-block bg-primary-600 hover:bg-primary-700 text-white font-medium py-2 px-6 rounded-md transition duration-300" data-id="element-571">
                    了解更多
                  </Link>
                </div>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-572">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-573">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-574">
            需要更多信息？
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-575">
            如果您对我们的产品和服务有任何疑问，或者需要定制化的解决方案，请随时联系我们。
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-576">
            <Link to="/about/contact" className="inline-block bg-primary-600 hover:bg-primary-700 text-white font-medium py-3 px-8 rounded-md transition duration-300" data-id="element-577">
              联系我们
            </Link>
            <Link to="/solutions" className="inline-block bg-white text-primary-600 font-medium py-3 px-8 rounded-md border border-primary-600 transition duration-300 hover:bg-primary-50" data-id="element-578">
              查看解决方案
            </Link>
          </div>
        </div>
      </section>
    </div>;
};
export default ProductsPage;